export default __webpack_public_path__ + "static/anadir_una_poliza-f550b51dac6d98355ca6f513f3653e7d.mp4";